import { useState } from 'react';
import { LoginPassword } from './LoginPassword';
import { LoginMagicLink } from './MagicLink/LoginMagicLink';
import { LoginContext } from './context';
import { StatusBanner } from '@components';
import { t } from 'i18next';
import { isDev } from '@common/types/utilities.ts';
import { Box } from '@mui/material';

const STEP_LIMIT = 3;

const renderStep = (step: number) => {
  switch (step) {
    case 1:
      return <LoginMagicLink />;
    case 0:
    default:
      return <LoginPassword />;
  }
};

export const Login = () => {
  const isStaging = isDev();

  const [step, setStep] = useState<number>(0);
  const [email, setEmail] = useState<string>('');

  const handlePreviousStep = () => {
    if (step > 0) {
      setStep(step - 1);
    }
  };

  const handleNextStep = () => {
    if (step < STEP_LIMIT) {
      setStep(step + 1);
    }
  };

  const contextValues = {
    step,
    handleNextStep,
    handlePreviousStep,
    email,
    setEmail,
  };

  return (
    <LoginContext.Provider value={contextValues}>
      {isStaging && (
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
          }}
        >
          <StatusBanner text={t('general.isStaging')} variant='error' />
        </Box>
      )}
      {renderStep(step)}
    </LoginContext.Provider>
  );
};
